import type { StateCreator } from 'zustand';
import type { MonitoringSlices } from '.';

import type { Destination, Vehicle, VehicleGroup } from '@cobliteam/common-types';

import type { DeviceFragment, DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

import SortType from '../../types/SortType';

interface VehiclesFilters {
  vehicles: Vehicle[];
  vehicleGroups: VehicleGroup[];
  deviceStatus: DeviceGeneralStatus[];
  searchBox: string;
  sort: SortType;
}

interface VehiclesSlice {
  vehiclesFilters: VehiclesFilters;
  setVehiclesFilters: (filters: Partial<VehiclesFilters>) => void;

  etaDialog: boolean;
  setEtaDialog: (etaDialog: boolean) => void;

  destination?: Destination;
  setDestination: (destination?: Destination) => void;

  selectedDevice?: DeviceFragment;
  setSelectedDevice: (device?: DeviceFragment) => void;
}

type StateCreatorVehicles = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], VehiclesSlice>;

const createVehiclesSlice: StateCreatorVehicles = (set) => ({
  vehiclesFilters: {
    vehicles: [],
    vehicleGroups: [],
    deviceStatus: [],
    searchBox: '',
    sort: SortType.ON,
  },
  setVehiclesFilters: (filters: Partial<VehiclesFilters>) =>
    set((state) => ({
      vehiclesFilters: { ...state.vehiclesFilters, ...filters },
    })),

  etaDialog: false,
  setEtaDialog: (etaDialog: boolean) => set({ etaDialog }),

  destination: undefined,
  setDestination: (destination?: Destination) => set({ destination }),

  selectedDevice: undefined,
  setSelectedDevice: (device?: DeviceFragment) => set({ selectedDevice: device }),
});

export type { VehiclesSlice, VehiclesFilters };
export default createVehiclesSlice;
